/**
 * LocalStorage key constants
 */

export const LOCALSTORAGE_KEYS = {
  CASE_MANAGEMENT_SORT_CONFIG: "caseManagement_sortConfig",
} as const;
